export default "__VITE_PUBLIC_ASSET__2c12a8ea__"